import React from 'react';
import Navbar from '../Homepage/Navbar';
import Footer from '../Homepage/Footer';

const InnovationAwards = () => {
    return (
        <div className="min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-grow pt-32 pb-20 bg-dark-secondary">
                <div className="max-w-4xl mx-auto px-4">
                    <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-6 text-center">Innovation <span className="text-nvcti-orange">Awards</span></h1>
                    <p className="text-xl text-gray-300 mb-16 text-center max-w-2xl mx-auto">NVCTI promotes excellence and creativity through prestigious awards and fellowships for student innovators.</p>

                    <div className="space-y-10">
                        <div className="bg-dark-tertiary p-8 md:p-10 rounded-2xl shadow-xl border border-white/5 hover:border-nvcti-orange/30 transition-all duration-300">
                            <h2 className="text-2xl font-bold text-white mb-3 flex items-center gap-3">
                                <span className="w-2 h-8 bg-nvcti-orange rounded-full"></span>
                                Srinivasan Padmanabhan Academic Award
                            </h2>
                            <p className="text-2xl font-black text-nvcti-orange mb-6 tracking-tight">💰 ₹90,000 <span className="text-sm font-normal text-gray-400">(approx.)</span></p>
                            <p className="text-gray-300 text-lg leading-relaxed italic border-l-2 border-white/10 pl-4">Recognizes academic excellence with innovation aptitude each year.</p>
                        </div>

                        <div className="bg-dark-tertiary p-8 md:p-10 rounded-2xl shadow-xl border border-white/5 hover:border-purple-500/30 transition-all duration-300">
                            <h2 className="text-2xl font-bold text-white mb-3 flex items-center gap-3">
                                <span className="w-2 h-8 bg-purple-500 rounded-full"></span>
                                Smt. Lalitha Srinivasan Innovation & Invention Award
                            </h2>
                            <p className="text-2xl font-black text-purple-400 mb-6 tracking-tight">💰 ₹4,00,000 <span className="text-sm font-normal text-gray-400">(approx.)</span></p>
                            <p className="text-gray-300 text-lg leading-relaxed italic border-l-2 border-white/10 pl-4">A top-tier award for impactful and original student-led inventions.</p>
                        </div>

                        <div className="bg-dark-tertiary p-8 md:p-10 rounded-2xl shadow-xl border border-white/5 hover:border-blue-500/30 transition-all duration-300">
                            <h2 className="text-2xl font-bold text-white mb-3 flex items-center gap-3">
                                <span className="w-2 h-8 bg-blue-500 rounded-full"></span>
                                Piyush Dutta Innovation and Invention Prize
                            </h2>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-8">
                                <div className="p-4 bg-accent-primary rounded-xl flex justify-between items-center shadow-inner">
                                    <span className="font-bold text-white">1st Year</span>
                                    <span className="text-white font-black">$300</span>
                                </div>
                                <div className="p-4 bg-accent-primary rounded-xl flex justify-between items-center shadow-inner">
                                    <span className="font-bold text-white">2nd Year</span>
                                    <span className="text-white font-black">$600</span>
                                </div>
                                <div className="p-4 bg-accent-primary rounded-xl flex justify-between items-center shadow-inner">
                                    <span className="font-bold text-white">3rd Year</span>
                                    <span className="text-white font-black">$900</span>
                                </div>
                                <div className="p-4 bg-accent-primary rounded-xl flex justify-between items-center shadow-inner">
                                    <span className="font-bold text-white">4th Year</span>
                                    <span className="text-white font-black">$1200</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default InnovationAwards;
